




















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { CircleIcon, DiscIcon } from 'vue-feather-icons';

@Component({
  components: { CircleIcon, DiscIcon },
})
export default class Rating extends Vue {
  @Prop({ required: true, type: [Number], default: () => '' })
  readonly value!: number;
}
